import React from "react";

import { useContents } from "fond/hooks/useContents";
import { BaseProjectList } from "fond/projects/BaseProjectList";

/**
 * A filterable list of projects displayed to the user within a DataGrid including Column Sorting and Pagination
 */
const SharedContentList: React.FC = () => {
  const { sharedItems } = useContents();

  return <BaseProjectList items={sharedItems} />;
};

export default SharedContentList;
